export function FieldMessages({
  hintId,
  hint,
  errorId,
  error,
}: {
  hintId: string
  hint?: string
  errorId: string
  error?: string
}) {
  return (
    <>
      {hint && (
        <p id={hintId} className="text-xs text-[var(--surface-muted)]">
          {hint}
        </p>
      )}
      {error && (
        <p id={errorId} className="text-xs font-medium text-red-300">
          {error}
        </p>
      )}
    </>
  )
}
